<template>
  <v-app>
    <v-app-bar v-if="$route.name !== 'campaigns'" short elevation="0" app>
      <div class="container d-flex">
        <router-link to="/">
          <v-img src="./assets/logo.png" contain style="width: 150px" class="mr-2"></v-img>
        </router-link>
        <v-toolbar-items v-if="$route.name !== 'get-started'">
          <v-btn
            text
            :ripple="false"
            active-class="nav-link-active"
            class="d-none d-md-flex nav-link text-capitalize"
            to="/about"
            >{{ $t("common.about") }}</v-btn
          >
          <v-menu offset-y open-on-hover>
            <!--            <template v-slot:activator="{ on }">-->
            <!--              <v-btn text :ripple=false active-class="nav-link-active" class="d-none d-md-flex nav-link text-capitalize" v-on="on">Services<v-icon right small>mdi-menu-down</v-icon></v-btn>-->
            <!--            </template>-->
            <v-list nav dense>
              <v-list-item to="/brands" exact-active-class="test-class">
                <v-list-item-title>Influencer Marketing</v-list-item-title>
              </v-list-item>
              <v-list-item to="/influencers" exact-active-class="test-class">
                <v-list-item-title>experiential marketing</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-menu offset-y open-on-hover>
            <template v-slot:activator="{ on }">
              <v-btn
                text
                :ripple="false"
                active-class="nav-link-active"
                class="d-none d-md-flex nav-link text-capitalize"
                v-on="on"
              >
                {{ $t("common.solutions") }}
                <v-icon right small>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list nav dense>
              <v-list-item to="/brands" exact-active-class="test-class">
                <v-list-item-title>{{ $t("common.influencer-marketing") }}</v-list-item-title>
              </v-list-item>
              <v-list-item to="/insights" exact-active-class="test-class">
                <v-list-item-title>{{ $t("common.social-insights") }}</v-list-item-title>
              </v-list-item>
              <v-list-item to="/brands" exact-active-class="test-class">
                <v-list-item-title>{{ $t("common.brands") }}</v-list-item-title>
              </v-list-item>
              <v-list-item to="/influencers" exact-active-class="test-class">
                <v-list-item-title>{{ $t("common.influencers") }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!--        <v-btn text :ripple=false active-class="nav-link-active" class="d-none d-md-flex nav-link" to="pricing">{{ $t('common.pricing')}}</v-btn>-->
          <v-btn
            text
            :ripple="false"
            active-class="nav-link-active"
            class="d-none d-md-flex nav-link text-capitalize"
            to="/support"
            >{{ $t("common.support") }}</v-btn
          >
          <!--          <v-btn text :ripple=false active-class="nav-link-active" class="d-none d-md-flex nav-link text-capitalize" @click.stop="dialog = !dialog">{{ $t('common.sign-in')}}</v-btn>-->
        </v-toolbar-items>
      </div>
      <div class="flex-grow-1 d-none d-md-flex"></div>
      <v-btn
        @click.stop="dialog = !dialog"
        outlined
        color="primary"
        v-if="$route.name !== 'get-started'"
        class="mr-2 d-none d-md-flex"
        >{{ $t("common.sign-in") }}</v-btn
      >
      <v-btn
        depressed
        color="primary"
        v-if="$route.name !== 'get-started'"
        class="mr-2 d-none d-md-flex"
        @click.stop="registerDialog = !registerDialog"
        >{{ $t("common.sign-up") }}</v-btn
      >
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" icon>
            <v-icon>mdi-translate</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item-group v-model="local">
            <v-list-item value="en-au">
              <v-list-item-title>English</v-list-item-title>
            </v-list-item>
            <v-list-item value="zh-cn">
              <v-list-item-title>中文</v-list-item-title>
            </v-list-item>
            <!--            <v-list-item value="ja">-->
            <!--              <v-list-item-title>-->
            <!--                日本語-->
            <!--              </v-list-item-title>-->
            <!--            </v-list-item>-->
          </v-list-item-group>
        </v-list>
      </v-menu>
      <v-app-bar-nav-icon
        class="d-flex d-md-none"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app clipped temporary right>
      <v-list nav dense>
        <v-list-item-group
          v-model="group"
          active-class="indigo darken-4 white--text text--accent-4"
        >
          <v-list-item to="/about">
            <v-list-item-title>{{ $t("common.about") }}</v-list-item-title>
          </v-list-item>

          <v-list-item to="/brands">
            <v-list-item-title>{{ $t("common.brands") }}</v-list-item-title>
          </v-list-item>

          <v-list-item to="/influencers">
            <v-list-item-title>{{ $t("common.influencers") }}</v-list-item-title>
          </v-list-item>
          <!--          <v-list-item to="pricing">-->
          <!--            <v-list-item-title>{{ $t('common.pricing')}}</v-list-item-title>-->
          <!--          </v-list-item>-->

          <v-list-item to="/support">
            <v-list-item-title>{{ $t("common.support") }}</v-list-item-title>
          </v-list-item>
          <v-list-item>
            <v-btn outlined color="primary" @click.stop="dialog = !dialog">{{
              $t("common.sign-in")
            }}</v-btn>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
    <v-main v-scroll="onScroll">
      <v-container class="root-container">
        <router-view />
        <v-dialog v-model="dialog" max-width="1070">
          <v-card class="px-10 pt-10 pb-10">
            <v-row>
              <v-col :md="4" :sm="12" @click="handleOpenLogin('insight')">
                <NaviGuide
                  :title="$t('home.social-insights')"
                  :desc="$t('home.social-insights-desc')"
                  :img="imgInsight"
                />
              </v-col>
              <v-col :md="4" :sm="12" @click="handleOpenLogin('brand')">
                <NaviGuide
                  :title="$t('home.brand')"
                  :desc="$t('home.brand-desc')"
                  :img="imgBrand"
                />
              </v-col>
              <v-col :md="4" :sm="12" @click="handleOpenLogin('kol')" >
                <NaviGuide
                  :title="$t('home.influcer')"
                  :desc="$t('home.influcer-desc')"
                  :img="imgKol"
                  />
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
        <v-dialog v-model="registerDialog" max-width="1070">
          <v-card class="px-10 pt-10 pb-10">
            <v-row>
              <v-col :md="4" :sm="12" @click="handleOpen('insight')">
                <NaviGuide
                  :title="$t('home.social-insights')"
                  :desc="$t('home.social-insights-desc')"
                  :img="imgInsight" />
              </v-col>
              <v-col :md="4" :sm="12" @click="handleOpen('brand')">
                <NaviGuide
                  :title="$t('home.brand')"
                  :desc="$t('home.brand-desc')"
                  :img="imgBrand" />
              </v-col>
              <v-col :md="4" :sm="12" @click="handleOpen('kol')">
                <NaviGuide
                  :title="$t('home.influcer')"
                  :desc="$t('home.influcer-desc')"
                  :img="imgKol" />
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
    <v-footer v-if="$route.name !== 'campaigns'">
      <v-container class="root-container">
        <v-card flat tile class="transparent lighten-1 text-center" width="100%">
          <v-row justify="space-between">
            <v-col cols="6" md="4">
              <h5 class="text-left">{{ $t("common.about") }}</h5>
              <v-list-item-group>
                <v-list-item class="px-0" :ripple="false" to="/contact-us" dense>
                  <v-list-item-content>
                    <v-list-item-title class="text-left">{{
                      $t("common.contact-us")
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  class="px-0"
                  :ripple="false"
                  dense
                  href="https://add-data.io"
                  target="_blank"
                >
                  <v-list-item-content>
                    <v-list-item-title class="text-left">{{
                      $t("common.add-data")
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0" :ripple="false" to="/careers" dense>
                  <v-list-item-content>
                    <v-list-item-title class="text-left">{{
                      $t("common.careers")
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item class="px-0" :ripple="false" to="/news" dense>
                  <v-list-item-content>
                    <v-list-item-title class="text-left">{{ $t("common.news") }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-col>
            <!--            <v-col cols=6 sm=3 md=2 xs="12">-->
            <!--              <h5 class="text-left">{{ $t('common.brands')}}</h5>-->
            <!--              <v-list-item-group>-->
            <!--                <v-list-item class="px-0" :ripple="false" dense>-->
            <!--                  <v-list-item-content>-->
            <!--                    <v-list-item-title class="text-left">Features</v-list-item-title>-->
            <!--                  </v-list-item-content>-->
            <!--                </v-list-item>-->
            <!--              </v-list-item-group>-->
            <!--            </v-col>-->
            <!--            <v-col cols=6 sm=3 md=2 xs="12">-->
            <!--              <h5 class="text-left">{{ $t('common.influencers')}}</h5>-->
            <!--              <v-list-item-group>-->
            <!--                <v-list-item class="px-0" :ripple="false" dense>-->
            <!--                  <v-list-item-content>-->
            <!--                    <v-list-item-title class="text-left">Features</v-list-item-title>-->
            <!--                  </v-list-item-content>-->
            <!--                </v-list-item>-->
            <!--              </v-list-item-group>-->
            <!--            </v-col>-->
            <v-col cols="6" md="3">
              <h5 class="text-left">{{ $t("common.resources") }}</h5>
              <v-list-item-group>
                <!--                <v-list-item class="px-0" :ripple="false" dense href="https://status.navigate.network" target="_blank">-->
                <!--                  <v-list-item-content>-->
                <!--                    <v-list-item-title class="text-left">{{ $t('common.service-status')}}</v-list-item-title>-->
                <!--                  </v-list-item-content>-->
                <!--                </v-list-item>-->
                <v-list-item
                  class="px-0"
                  :ripple="false"
                  dense
                  href="https://support.navigate.network"
                  target="_blank"
                >
                  <v-list-item-content>
                    <v-list-item-title class="text-left">{{
                      $t("common.support")
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <!--                <v-list-item class="px-0" :ripple="false" dense>-->
                <!--                  <v-list-item-content>-->
                <!--                    <v-list-item-title class="text-left">{{ $t('common.documentation')}}</v-list-item-title>-->
                <!--                  </v-list-item-content>-->
                <!--                </v-list-item>-->
                <!--                <v-list-item class="px-0" :ripple="false" dense>-->
                <!--                  <v-list-item-content>-->
                <!--                    <v-list-item-title class="text-left">{{ $t('common.help')}}</v-list-item-title>-->
                <!--                  </v-list-item-content>-->
                <!--                </v-list-item>-->
              </v-list-item-group>
            </v-col>

            <v-col cols="12" md="5" align="end" align-self="end">
              <v-btn
                v-for="(icon, i) in icons"
                :key="i"
                class="ml-1"
                icon
                :href="icon.link"
                target="_blank"
              >
                <v-icon size="24px">{{ icon.icon }}</v-icon>
              </v-btn>
              <v-menu open-on-hover top offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" class="ml-3">
                    <v-icon>mdi-wechat</v-icon>
                  </v-btn>
                </template>
                <v-container>
                  <v-img
                    src="./assets/qrcode_navigatenetwork.jpg"
                    contain
                    style="width: 150px"
                  ></v-img>
                </v-container>
              </v-menu>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-card-text>
            &copy; {{ new Date().getFullYear() }}
            <strong class="font-weight-light">The Navigate Network -</strong>
            &nbsp;a
            <a href="https://2dm.digital">2dm</a>
            <a href="https://add-data.io">+Data</a> initiative
            <v-btn text rounded to="/privacy-policy">{{ $t("common.privacy-policy") }}</v-btn>
            <v-btn text rounded to="/terms-of-use">{{ $t("common.tos") }}</v-btn>
          </v-card-text>
        </v-card>
      </v-container>
    </v-footer>
    <v-sheet
      transition="scroll-y-transition"
      class="cookie-consent"
      elevation="12"
      v-show="showConsent"
    >
      <v-container fluid>
        <v-row>
          <v-col>
            <v-card flat class="mx-auto">
              <v-card-text class="pa-2">
                <div>{{ $t("common.consent-copy") }}</div>
              </v-card-text>
              <v-card-actions>
                <v-btn text outlined @click="showConsent = !showConsent">{{
                  $t("common.consent")
                }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>
  </v-app>
</template>

<script>
import NaviGuide from './components/NaviGuide';

export default {
  components: {
    NaviGuide,
  },
  name: 'App',
  data: () => ({
    kolWeb: `${process.env.VUE_APP_NAVIGATE_KOL}`,
    brandWeb: `${process.env.VUE_APP_NAVIGATE_BRAND}`,
    insightsWeb: `${process.env.VUE_APP_NAVIGATE_INSIGHTS}`,
    brandRegister: `${process.env.VUE_APP_NAVIGATE_BRAND}register`,
    kolRegister: `${process.env.VUE_APP_NAVIGATE_KOL}register`,
    env: process.env,
    email: '',
    drawer: false,
    group: null,
    showConsent: true,
    local: null,
    dialog: false,
    registerDialog: false,
    icons: [
      {
        icon: 'mdi-facebook',
        link: 'https://www.facebook.com/NavigateNetwork/',
      },
      {
        icon: 'mdi-instagram',
        link: 'https://www.instagram.com/navigate_network/',
      },
      {
        icon: 'mdi-twitter',
        link: 'https://twitter.com/NavigateNetwork',
      },
      {
        icon: 'mdi-sina-weibo',
        link: 'https://www.weibo.com/u/7249715114',
      },
      {
        icon: 'mdi-linkedin',
        link: 'https://www.linkedin.com/company/NavigateNetwork/',
      },
    ],
    hideNavBar: false,
    // eslint-disable-next-line global-require
    imgInsight: require('./assets/person-insights.svg'),
    // eslint-disable-next-line global-require
    imgBrand: require('./assets/person-brand.svg'),
    // eslint-disable-next-line global-require
    imgKol: require('./assets/person-kol.svg'),
  }),
  watch: {
    $route(to) {
      if (to.path.indexOf('/c/') !== -1) {
        this.showConsent = false;
      }
    },
    group() {
      this.drawer = false;
    },
    showConsent(value) {
      localStorage.cookieConsent = !value;
    },
    local(newLocal, oldLocal) {
      this.$i18n.locale = newLocal;
      localStorage.lang = this.$i18n.locale;
      this.$router.go();
    },
  },
  mounted() {
    if (!localStorage.lang) {
      localStorage.lang = this.$i18n.locale;
    }
    if (localStorage.cookieConsent) {
      console.log('browser language', navigator.languages, this.$i18n.locale);
      this.showConsent = false;
    }
    window.Intercom('boot', {
      app_id: 'gy2sapjn',
      custom_launcher_selector: '#open_intercom_chat',
    });
  },
  methods: {
    handleOpenLogin(str) {
      // eslint-disable-next-line no-restricted-globals
      if (str === 'kol') location.href = `${this.kolWeb}login`;// window.open();
      // eslint-disable-next-line no-restricted-globals
      if (str === 'insight') location.href = `${this.insightsWeb}?type=login`;
      // eslint-disable-next-line no-restricted-globals
      if (str === 'brand') location.href = `${this.brandWeb}login`;
    },
    handleOpen(str) {
      // eslint-disable-next-line no-restricted-globals
      if (str === 'kol') location.href = `${this.kolWeb}register`;// window.open();
      // eslint-disable-next-line no-restricted-globals
      if (str === 'insight') location.href = `${this.insightsWeb}?type=register`;
      // eslint-disable-next-line no-restricted-globals
      if (str === 'brand') location.href = `${this.brandWeb}register`;
    },
    sendMessage() {
      console.log(this.email);
    },
    onScroll(e) {
      this.hideNavBar = true;
    },
  },
};
</script>

<style>
@font-face {
  font-family: Maxwell;
  font-weight: 400;
  font-size: 118px;
  src: url("assets/fonts/maxwell_regular-webfont.woff") format("woff");
}
@font-face {
  font-family: "Noto Sans SC", sans-serif;
}

html {
  font-family: Maxwell, Noto Sans SC, serif;
}
.hero-text {
  font-family: Maxwell, Arial, serif;
  font-size: 60px;
  line-height: 60px;
}
.root-container {
  max-width: 76.875rem !important;
}
.hero {
  background-image: url(https://navigate-network.s3-ap-southeast-1.amazonaws.com/assets/hipster_hippie_emo_concrete_portrait_empty_space-869397.jpg);
  background-size: cover;
  /* Set a specific height */
  min-height: 800px;
  /* Create the parallax scrolling effect */
  background-attachment: fixed;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.nav-link-active:before {
  opacity: 0 !important;
}

.nav-link:hover {
  /*text-decoration: underline;*/
}
.cookie-consent {
  position: fixed !important;
  bottom: 0;
  left: 0;
}

.nav-link-active span {
  font-weight: bold;
  color: #262262;
  border-bottom: #262262;
}
.front {
  z-index: 9999 !important;
}
.test-class:before {
  background-color: transparent !important;
}
</style>
